<template>
  <div style="background: #f2f2f2;">
    <div class="container yu_fc index_top particles_box">
      <img class="img_position1" src="../assets/images/sjp_xcx.jpg" />
      <img class="img_position2" src="../assets/images/sjp_app.jpg" />
      <div class="index_top_left">
        <template v-for="(item, index) in navArr">
          <div class="index_top_left_box" :key="index">
            <a class="link" href="javascript:void(0)" @mouseover="mouseOver(item.productCategoryId,item.productCategoryName)" @mouseleave="mouseLeave" @click="onClass(item.productCategoryId,item.productCategoryName)"><p>{{item.productCategoryName}}</p>
              <!-- <i class="el-icon-arrow-right"></i> -->
            </a>
            <div class="box">
              <dl v-for="(value, indet) in navChild.children" :key="indet">
                <dt>{{classSplit(value.name)}}</dt>
                <dd>
                  <a href="javascript:void(0)" v-for="(clasy, index) in value.children" :key="index" @click="onClasy(navId,clasy.id,navName)">{{clasy.name}}</a>
                </dd>
              </dl>
            </div>
          </div>
        </template>
      </div>
      <!-- banner -->
      <div class="banner">
        <el-carousel :interval="5000" trigger="click" height="510px">
          <el-carousel-item v-for="(slide, index) in indexAdvertiseSwiper" :key="index" :style="{ 'background-image': 'url(' + slide.pic + ')' }"><a href="javascript:void(0)" @click="onSwiper(slide.productCategoryId, slide.name)"></a>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- <div class="special top">
    </div> -->
    <div class="special_pic2">
      <div
        class="image_21"
        referrerpolicy="no-referrer">
      </div>
      <div 
        class="image_text_21" @click="onSubject('152')">更多 >
      </div>
    </div>
    <div class="item_list">
      <li v-for="(item, index) in goodsArr1" :key="index">
        <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.pic" /></a>
        <div class="label">
        </div>
        <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
        <div class="price">
          <span>￥{{item.price}}</span>
          <del>￥{{item.originalPrice}}</del>
        </div>
      </li>
    </div>
    <div class="special_pic3">
      <div
        class="image_31"
        referrerpolicy="no-referrer">
      </div>
      <div 
        class="image_text_21" @click="onSubject('175')">更多 >
      </div>
    </div>
    <div class="item_list">
      <li v-for="(item, index) in goodsArr2" :key="index">
        <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.pic" /></a>
        <div class="label">
        </div>
        <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
        <div class="price">
          <span>￥{{item.price}}</span>
          <del>￥{{item.originalPrice}}</del>
        </div>
      </li>
    </div>
    <!-- 优惠券 -->
    <!-- <div class="coupon particles_box"><img src="../assets/images/pic_6.jpg" /></div> -->
    <div class="special_top" v-if="showBcbp">
      <div class="box_72" @click="showBcbp1" >
        <div class="text_60">本场爆品</div>
        <div class="text-wrapper_34">
          <span class="text_61">大家都在买</span>
        </div>
      </div>
      <div class="box_71">
      </div>
      <div class="box_73" @click="showBcbp2" >
        <div class="text_62">本场秒杀</div>
        <div class="text-wrapper_35">
          <div class="text_64">抢购中</div>
        </div>
      </div>
    </div>
    <div class="special_top" v-if="!showBcbp">
      <div class="box_73" @click="showBcbp1" >
        <div class="text_62">本场爆品</div>
        <div class="text-wrapper_35">
          <div class="text_63">大家都在买</div>
        </div>
      </div>
      <div class="box_71">
      </div>
      <div class="box_72" @click="showBcbp2" >
        <div class="text_60">本场秒杀</div>
        <div class="text-wrapper_34">
          <div class="text_61">抢购中</div>
        </div>
      </div>
    </div>
    <div class="item_list1" v-if="showBcbp">
      <li v-for="(item, index) in goodsArr3" :key="index">
        <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.picHome" /></a>
        <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
        <div class="price">
          <span>折扣价:￥{{item.price}}</span>
          <del>销售价:￥{{item.originalPrice}}</del>
        </div>
        <div class="btn">
          <btn1 @click="onClasy((item.productCategoryId+'').substring(0,2),item.productCategoryId, item.productCategoryName.split('-')[0])">进入{{item.productCategoryName.split('-')[2]}}专区<i class="el-icon-my-export1"></i></btn1>
          <btn2></btn2>
          <btn3>购买</btn3>
        </div>
      </li>
    </div>
    <div class="item_list1" v-if="!showBcbp">
      <li v-for="(item, index) in goodsArr4" :key="index">
        <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.picHome" /></a>
        <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
        <div class="price">
          <span>折扣价:￥{{item.price}}</span>
          <del>销售价:￥{{item.originalPrice}}</del>
        </div>
        <div class="btn">
          <btn1 @click="onClasy((item.productCategoryId+'').substring(0,2),item.productCategoryId, item.productCategoryName.split('-')[0])">进入{{item.productCategoryName.split('-')[2]}}专区<i class="el-icon-my-export1"></i></btn1>
          <btn2></btn2>
          <btn3>购买</btn3>
        </div>
      </li>
    </div>
    <!-- 为你推荐 -->
    <div class="text-group_00">
      <span class="text_002">为您推荐</span>
      <span class="text_001">Recommended</span>
    </div>
    <!-- 楼层 -->
    <ul class="item_list">
      <li v-for="(item, index) in goodsArr" :key="index">
        <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')"><img :src="item.pic" /></a>
        <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.id,item.defaultSkuId,item.name, '为你推荐')">{{item.name}}</a>
        <div class="price">
          <span>￥{{item.price}}</span>
          <del>￥{{item.originalPrice}}</del>
        </div>
      </li>
    </ul>
    <!-- 楼层 -->
    <p class="foot_tips particles_box">搜天下精品，享精致生活</p>
  </div>
</template>

<script>
import Bus from "../bus.js";
//import { webIndex } from "@/api/index";
import { homeIndex } from "@/api/index";
import { productCategoryOne, productCategoryTwoThree } from "@/api/baseData";
import { productList } from "@/api/product";
export default {
  name: "index",
  data() {
    //let that = this;
    return {
      icon: "", //头像
      nick: "", //昵称
      phone: "", //手机号码
      banArr: [], // banner
      navArr: [], // 一级导航数据
      navChild: [], // 二三级数据
      navId: "", // 一级分类id
      navName: "", // 一级分类名字
      discount: [], // 拼团嗨购
      // swiper-拼团嗨购
      // imgIndex: 1,
      swiperDiscount: {
        slidesPerView: 4,
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 小手掌抓取滑动
        // grabCursor: true,
        // 滑动之后回调函数
        // on: {
        //  slideChangeTransitionStart: function() {
        //    that.imgIndex = this.realIndex + 1;
        //    //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
        //    },
        // },
        navigation: {
          nextEl: ".swiper-button-next-discount", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev-discount" //后退按钮的css选择器或HTML元素。
        }
        // 分页器设置
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   type: "bullets"
        // }
      },
      quality: [], // 精品推荐
      // swiper-精品推荐
      swiperQuality: {
        slidesPerView: 4,
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next-quality",
          prevEl: ".swiper-button-prev-quality"
        }
      },
      floorArr: [], // 楼层
      indexAdvertiseSwiper: [], // 轮播图
      // indexAdvertiseHomePageAd: [], // 广告位
      // indexActivityProduct: [], // 首页活动商品//1 新人专享//2 限时购//3 每日爆款//4 拼团嗨购//5 9.9
      // indexActivityProductXrzx: {}, // 新人专享
      // indexActivityProductXsga: {}, // 限时购
      // indexActivityProductMrbk: {}, // 每日爆款
      // indexActivityProductPthg: {}, // 拼团嗨购
      // indexActivityProductNine: {}, // 9.9
      // indexOperateListHomePage: [], // 优惠中心
      subjectResultList: [],
      subjectResult: {},
      subjectResultExtra: {},
      showBcbp: true,
      goodsArr: [], // 推荐
      goodsArr1: [], // 推荐
      goodsArr2: [], // 推荐
      goodsArr3: [], // 推荐
      goodsArr4: [] // 推荐
    };
  },
  created() {
    this.webIndex();
    this.categoryOne();
    this.getGoods()
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.icon = userInfo.icon
    this.nick = userInfo.nick
    this.phone = userInfo.phone
    localStorage.removeItem("className");
    localStorage.removeItem("classImg");
    localStorage.removeItem("classIndex");
    localStorage.removeItem("classId");
  },
  methods: {
    async webIndex() {
      // const res = await webIndex();
      const res = await homeIndex();
      console.log('------------------------------------------------', res)
      if (res.code == 200) {
        this.indexAdvertiseSwiper = res.data.rollList
        // this.indexAdvertiseSwiper = res.data.advertiseRotationListHomePage
        // this.indexAdvertiseHomePageAd = res.data.advertiseOperateListHomePage
        // this.indexActivityProduct = res.data.activityProductListHomePage
        // this.indexActivityProductXrzx = res.data.activityProductListHomePage[0]
        // this.indexActivityProductXsga = res.data.activityProductListHomePage[1]
        // this.indexActivityProductMrbk = res.data.activityProductListHomePage[2]
        // this.indexActivityProductPthg = res.data.activityProductListHomePage[3]
        // this.indexActivityProductNine = res.data.activityProductListHomePage[4]
        this.subjectResultList = res.data.subjectResultList
        this.subjectResult = res.data.subjectResult
        this.subjectResultExtra = res.data.subjectResultExtra
        console.log('1------------------------------------------------', this.subjectResultList)
        console.log('2------------------------------------------------', this.subjectResult)
        console.log('3------------------------------------------------', this.subjectResultExtra)
        let len = res.data.subjectResultList.length;
        this.goodsArr1 = res.data.subjectResultList[len-2].shortSubjectProductResult;
        this.goodsArr2 = res.data.subjectResultList[len-1].shortSubjectProductResult;
        this.goodsArr3 = res.data.subjectResult.shortSubjectProductResult;
        this.goodsArr4 = res.data.subjectResultExtra.shortSubjectProductResult;
      }
    },
    // 一级分类数据
    async categoryOne() {
      const res = await productCategoryOne();
      console.log(res);
      if (res.code == 200) {
        this.navArr = res.data;
      }
    },
    // 一级分类hover
    mouseOver(id, name) {
      this.navId = id;
      this.navName = name;
      this.categoryTwoThree(id);
    },
    mouseLeave() {
      console.log("mouseLeave");
    },
    // 二三级分类数据
    async categoryTwoThree(id) {
      const res = await productCategoryTwoThree({
        product_category_id: id
      });
      console.log(res);
      if (res.code == 200) {
        this.navChild = res.data[0];
      }
    },
    onSubject(id) {
      let router = this.$router.resolve({
        path: "/subject",
        query: {
          id: id
        }
      });
      window.open(router.href, "_self");
      // let classObj = {
      //   className: title,
      //   classId: id
      // }
      // Bus.$emit("classly", classObj);
      // this.ids = localStorage.getItem("classId");
      this.path = this.$route.path;
    },
    // 一级分类
    onClass(id, title) {
      let idsu = (id + "").substring(0, 2);
      let router = this.$router.resolve({
        path: "/classify",
        query: {
          id: idsu
        }
      });
      window.open(router.href, "_self");
      let classObj = {
        className: title,
        classId: id
      }
      Bus.$emit("classly", classObj);
      this.ids = localStorage.getItem("classId");
      this.path = this.$route.path;
    },
    // 三级分类
    onClasy(id, name, title) {
      console.log(id, name, title);
      let router = this.$router.resolve({
        path: "/classify",
        query: {
          id: id,
          name: name
        }
      });
      window.open(router.href, "_self");
      let classObj = {
        className: title,
        classId: id
      }
      Bus.$emit("classly", classObj);
      // localStorage.setItem("className", title);
      // localStorage.setItem("classId", id);
      this.ids = localStorage.getItem("classId");
      this.path = this.$route.path;
    },
    // 三级分类截取
    classSplit(name) {
      if (name.length > 5) {
        let val = name.substring(0, 5) + "...";
        return val;
      } else {
        return name;
      }
    },
    // 登出
    loginToast() {
      Bus.$emit("loginToast");
    },
    // 我的订单
    goOrder() {
      Bus.$emit("goOrder");
    },
    // 购物车
    goCar() {
      Bus.$emit("goCar");
    },
    // banner活动
    onSwiper(id, name) {
      console.log(id, name);
    },
    // 商品数据
    async getGoods() {
      const res = await productList({
        tabStatus: 3,
        pageSize: 200,
        pageNum: 1,
        order: 1
      })
      console.log(res);
      if (res.code == 200) {
        this.goodsArr = res.data.list;
        console.log(this.goodsArr);
        //this.goodsArr1 = res.data.list.slice(0,4);
        //this.goodsArr2 = res.data.list.slice(0,4);
        //this.goodsArr3 = res.data.list.slice(0,2);
        //this.goodsArr4 = res.data.list.slice(0,2);
      }
    },
    // 商品详情
    showBcbp1() {
      this.showBcbp = true
    },
    showBcbp2() {
      this.showBcbp = false
    },
    onGoodsDetail(id, skuId, proId, title) {
      console.log(id, skuId, proId, title);
      let router = this.$router.resolve({
        path: "/goodsDetail",
        query: {
          id: id,
          skuId: skuId
        }
      });
      window.open(router.href, "_blank");
      let classId = proId + "";
      console.log(classId);
      localStorage.setItem("className", title);
      localStorage.setItem("classId", classId.substring(0, 2));
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      // this.phone = localStorage.getItem("phone") ? localStorage.getItem("phone") : "";
      localStorage.removeItem("className");
      localStorage.removeItem("classImg");
      localStorage.removeItem("classIndex");
      localStorage.removeItem("classId");
    }
  },
  mounted() {
    // let _this = this;
    // Bus.$on("userInfo",function(user){
    //   console.log(user)
    //   _this.icon = user.icon
    //   _this.nick = user.nick
    //   _this.phone = user.phone
    // });
  }
};
</script>

<style scoped>
.index_top {
  padding: 10px 0 0;
  width: 1301px;
  height: 520px;
}
.img_position1 {
  position: fixed;
  top: 250px;
  right: 10px;
  width: 100px;
  margin-bottom: 8px;
}
.img_position2 {
  position: fixed;
  top: 370px;
  right: 10px;
  width: 100px;
  margin-bottom: 8px;
}
.index_top_left {
  float: left;
  width: 100px;
  height: 520px;
  background: rgba(255, 255, 255, 0.6);
  margin-right: 10px;
  position: relative;
}
.index_top_left .link {
  float: left;
  width: 160px;
  height: 32px;
  line-height: 32px;
  color: rgb(0, 0, 0);
  text-align: center;
  padding-right: 15px;
}
.index_top_left .link p {
  float: left;
  width: 100px;
  line-height: 32px;
  font-size: small;
  text-align: center;
}
.index_top_left .box {
  display: none;
  width: 1200px;
  height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(254, 252, 249, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  position: absolute;
  top: 0;
  left: 100px;
  z-index: 9;
}
/*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
.index_top_left .box::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/*内层轨道，滚动条中间部分（位置4）*/
.index_top_left .box::-webkit-scrollbar-track-piece {
  background: #fff;
}
/*滚动条里面可以拖动的那部分（位置5）*/
.index_top_left .box::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 4px;
}
.index_top_left .box dl {
  float: left;
  width: 800px;
}
.index_top_left .box dl dt {
  float: left;
  width: 156px;
  color: #333;
  line-height: 36px;
  font-weight: bold;
  text-align: right;
  padding-right: 54px;
  position: relative;
}
.index_top_left .box dl dt::after {
  content: "";
  width: 0;
  height: 0;
  display: inline-block;
  border-top: 1px solid;
  border-right: 1px solid;
  width: 9px;
  height: 9px;
  transform: rotate(45deg);
  position: absolute;
  top: 16px;
  right: 32px;
}
.index_top_left .box dl dd {
  float: left;
  width: 610px;
  min-height: 36px;
  /* padding: 12px 0; */
  border-bottom: 1px dashed rgba(218, 218, 218, 1);
}
.index_top_left .box dl:last-child dd {
  border: none;
}
.index_top_left .box dl dd a {
  float: left;
  color: #666;
  line-height: 36px;
  margin-right: 20px;
}
.index_top_left .box dl dd a:hover {
  color: rgba(180, 39, 45, 1);
}
.index_top_left_box:hover .link {
  color: #333;
  background: rgba(252, 243, 234, 1);
}
.index_top_left_box:hover .box {
  display: block;
}
/* banner */
.banner {
  float: left;
  width: 1190px;
  height: 510px;
  overflow: hidden;
  background: #fff;
}
.banner .el-carousel__item {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /* background-size: cover; */
}
.banner .el-carousel__item a {
  display: block;
  width: 100%;
  height: 100%;
}
.banner >>> .el-carousel__arrow {
  background-color: rgba(218, 206, 186, 1);
}
.banner >>> .el-carousel__arrow:hover {
  background-color: rgba(177, 158, 122, 1);
}
.banner >>> .el-carousel__indicators {
  bottom: 16px;
}
.banner >>> .el-carousel__indicator {
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0 3px;
  vertical-align: top;
}
.banner >>> .el-carousel__button {
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 100%;
  background: url("../assets/images/icon_0.png") no-repeat;
  background-position: -36px 0;
  opacity: 1;
  -webkit-transition: 0s;
  transition: 0s;
}
.banner >>> .is-active .el-carousel__button {
  background-position: -52px 0;
}
/* 专区 */
.special {
  margin: 10px auto;
}
.special.top  {
  width: 1301px;
  height: 168px;
  background: #FFFFFF;
  border-radius: 10px;
}
.special.pic  {
  margin-top: 20px;
  width: 1301px;
  height: 60px;
  background: #FFFFFF;
  border-radius: 10px;
}
.special .left {
  float: left;
  width: 200px;
  height: 338px;
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
  line-height: 338px;
  text-align: center;
  border-right: solid 1px rgba(218, 218, 218, 1);
  background: #fff;
}
.special.active .left{
  border-left: solid 1px rgba(218, 218, 218, 1);
}
.special .right {
  float: left;
  width: 999px;
  height: 338px;
  padding: 30px 0;
  background: #fff;
  position: relative;
}
.special .right .swiper_father {
  position: relative;
}
.special .right .swiper_father .swiper-button-prev,
.special .right .swiper_father .swiper-button-next {
  width: 35px;
  height: 35px;
  text-align: center;
  color: #fff;
  background: rgba(231, 226, 215, 1);
  border-radius: 50%;
}
.special .right .swiper_father .swiper-button-prev .el-icon-arrow-left,
.special .right .swiper_father .swiper-button-next .el-icon-arrow-right {
  font-size: 28px;
  margin-top: 3px;
}
.special .right .swiper_father .swiper-button-prev:hover,
.special .right .swiper_father .swiper-button-next:hover {
  background: rgba(210, 205, 194, 1);
}
.special .right .swiper_father .swiper_yhzq {
  width: 880px;
  margin: 0 auto;
}
.special .right .box {
  float: left;
  width: 220px;
  padding: 0 5px;
}
.special .right .box .box_s {
  float: left;
  width: 210px;
}
.special .right .box_s:hover {
  background: rgba(244, 240, 234, 1);
}
.special .right .box .top {
  float: left;
  width: 210px;
  height: 210px;
  font-size: 0;
  line-height: 0;
}
.special .right .box .top img {
  display: block;
  width: 210px;
  height: 210px;
}
.special .right .box .bot {
  float: left;
  width: 210px;
  height: 68px;
  text-align: center;
  padding: 24px 10px 10px;
}
.special .right .box .bot a {
  display: block;
  color: #333;
  line-height: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.special .right .box .bot p {
  padding-top: 10px;
}
.special .right .box .bot p span {
  color: rgba(221, 86, 91, 1);
  padding-right: 6px;
}
.special .right .box .bot p del {
  color: #999;
}
.foot_tips {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  padding: 30px 0;
}
/* 数据 */
.item_list{
  width: 1305px;
  min-height: 150px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item_list li{
  width: 314px;
  padding-right: 0px;
  text-align: center;
  padding-bottom: 0px;
  margin-top: 10px;
  margin-left: 3px;
  margin-right: 9px;
  margin-bottom: 0px;
  overflow: hidden;
  background: #FFFFFF;
}
.item_list li .img,
.item_list li .img img{
  float: left;
  width: 314px;
  height: 314px;
}
.item_list li .title{
  display: inline-block;
  color: #333;
  max-width: 100%;
  padding: 0 10px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 314px;
  height: 52px;
  font-size: 14px;
  padding-top: 14px;
}
.item_list li .price{
  padding-top: 21px;
  padding-bottom: 21px;
}
.item_list li .price span{
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
  color: #DA2833;
  padding-right: 6px
}
.item_list li .price del{
  font-size: 10px;
  display: inline-block;
  vertical-align: bottom;
  color: #999;
}
.special_pic2  {
  width: 1300px;
  height: 60px;
  background: url("../assets/images/icon_02.png")
    100% no-repeat;
  background-size: 100% 100%;
  /* margin: 20px 0 0 310px; */
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
}
.special_pic3  {
  width: 1300px;
  height: 60px;
  background: url("../assets/images/icon_03.png")
    100% no-repeat;
  background-size: 100% 100%;
  /* margin: 20px 0 0 310px; */
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
}
.image_21 {
  width: 158px;
  height: 30px;
  margin: 15px 0 0 20px;
  background: url("../assets/images/icon_021.png")
}
.image_31 {
  width: 158px;
  height: 30px;
  margin: 15px 0 0 20px;
  background: url("../assets/images/icon_031.png")
}
.image_text_21 {
  margin: 21px 0 0 1050px;
  float: right;
  width: 26px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-weight: NaN;
  white-space: nowrap;
  line-height: 18px;
}
.text_group_21 {
  margin-right: 100px;
  float: right;
  margin: 21px 20px 0 0;
  width: 26px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  font-weight: NaN;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
}
.text-group_00 {
  /* position: relative;
  width: 182px;
  height: 52px;
  margin: 50px 0 0 869px; */

    text-align: center;
  margin: 40px auto 30px;
  cursor: default;
}

.text_001 {
  background-image: linear-gradient(
    180deg,
    rgba(253, 252, 252, 1) 0,
    rgba(218, 218, 218, 1) 100%
  );
  width: 182px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 1);
  font-size: 24px;
  text-transform: uppercase;
  font-family: AlibabaPuHuiTi-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text_002 {
  position: absolute;
  margin: 0;
  margin-left: 45px;
  margin-top: -10px;
  width: 95px;
  height: 33px;
  overflow-wrap: break-word;
  color: rgba(34, 34, 34, 1);
  font-size: 24px;
  font-family: AlibabaPuHuiTi-Medium;
  font-weight: 500;
  white-space: nowrap;
  line-height: 33px;
}
.special_top {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  width: 1300px;
  height: 80px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.box_72 {
  width: 649px;
  height: 80px;
}
.box_71 {
width: 1px;
height: 80px;
border: 1px solid;
border-image: linear-gradient(207deg, rgba(255, 255, 255, 0), rgba(232, 232, 232, 1), rgba(255, 255, 255, 0)) 1 1;
}
.box_73 {
  width: 649px;
  height: 80px;
}

.text_60 {
  width: 80px;
  height: 27px;
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #222222;
  line-height: 27px;
  margin-left: 285px;
  margin-top: 13px;
}

.text-wrapper_34 {
  width: 117px;
  height: 24px;
  background: #E71D35;
  border-radius: 12px;
  margin-left: 267px;
}
.text-wrapper_35 {
  width: 117px;
  height: 24px;
  background: #ffffff;
  border-radius: 12px;
  margin-left: 267px;
}

.text_61 {
  width: 70px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 23px;
}

.image_14 {
  width: 1px;
  height: 80px;
  margin-left: 266px;
}

.text-group_60 {
  width: 80px;
  height: 53px;
  margin: 13px 285px 0 284px;
}

.text_62 {
  width: 80px;
  height: 27px;
  font-size: 20px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #222222;
  line-height: 27px;
  margin-left: 285px;
  margin-top: 13px;
}

.text_63 {
  width: 42px;
  height: 20px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
    text-align: center;
  white-space: nowrap;
  color: #CCCCCC;
  line-height: 20px;
    margin: 2px 0 0 23px;
}
.text_64 {
  width: 42px;
  height: 20px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
    text-align: center;
  white-space: nowrap;
  color: #CCCCCC;
  line-height: 20px;
    margin: 2px 0 0 35px;
}
.item_list1{
  width: 1305px;
  min-height: 150px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item_list1 li{
  width: 640px;
  height: 427px;
  padding-right: 0px;
  text-align: center;
  padding-bottom: 0px;
  margin-top: 10px;
  margin-left: 3px;
  margin-right: 9px;
  margin-bottom: 0px;
  overflow: hidden;
  background: #FFFFFF;
}
.item_list1 li .img,
.item_list1 li .img img{
  margin-left: 8px;
  margin-top: 8px;
  float: left;
  width: 608px;
  height: 294px;
}
.item_list1 li .title{
  float: left;
  margin-left: 30px;
  margin-top: 20px;
  width: 350px;
  height: 48px;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 24px;
  text-align: left
}
.item_list1 li .price{
  float: right;
  width: 200px;
}
.item_list1 li .price span{
  float: right;
  margin-top: 25px;
  width: 200px;
  height: 28px;
  font-size: 18px;
  color: #DA2833;
  text-align: right;
  padding-right: 20px;
}
.item_list1 li .price del{
  float: right;
  font-size: 10px;
  width: 200px;
  height: 20px;
  color: #999;
  text-align: right;
  padding-right: 20px;
}
.item_list1 li .btn{
  width: 590px;
  height: 36px;
  margin-left: 30px;
  top: 100px;
}
.item_list1 li .btn btn1{
  float: left;
  width: 200px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #E71D36;
  padding-top: 4px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E71D36;
    line-height: 21px;
    margin-top: 15px;
}
.el-icon-my-export1{
    background: url(../assets/images/icon_0101.png) center;
    background-size: 100% 100%;
  }
  .el-icon-my-export1:before{
    content: "\e611";
  }
.item_list1 li .btn btn2{
  margin-top: 10px;
  margin-left: 300px;
  float: left;
  width: 35px;
  height: 30px;
  background: #FC7103;
  border-radius: 4px 0px 0px 4px;
  padding-top: 8px;
  background-image: url(../assets/images/icon_0103.png);
  background-size: 100% 100%;
}
.item_list1 li .btn btn3{
  margin-top: 10px;
  float: left;
  width: 50px;
  height: 30px;
  background: linear-gradient(278deg, #E71D35 0%, #F31F6F 100%);
  border-radius: 0px 4px 4px 0px;
    padding-top: 8px;
}
  /* .el-icon-my-export3{
    background: url(../assets/images/icon_0103.png) center;
    background-size: cover;
  }
  .el-icon-my-export3:before{
    content: "\e611";
  } */
</style>